import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import "moment/locale/es";
import React from "react";

const ConveniosNomencladosDeletePrev = (props) => {
  const submitDeleteHandler = (e) => {
    e.preventDefault();

    const newPrevisualizacionArray = [...props.dataPrevisualizacionArray];
    newPrevisualizacionArray.splice(props.idCapituloEdit, 1);

    props.setDataPrevisualizacionArray(newPrevisualizacionArray);
    props.setShowDialogDelete(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        open={props.showDialogDelete}
        onClose={() => props.setShowDialogDelete(false)}
      >
        <DialogTitle>Eliminar Capítulo</DialogTitle>
        <DialogContent>
          <ValidatorForm onSubmit={submitDeleteHandler}>
            <Typography style={{ marginLeft: "2rem" }}>
              ¿Está seguro que desea eliminar el capítulo?
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: "1.5rem", float: "right", marginTop: "2rem" }}
              type="submit"
            >
              Confirmar
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: "1.5rem", float: "right", marginTop: "2rem" }}
              onClick={() => {
                props.setShowDialogDelete(false);
              }}
            >
              Cancelar
            </Button>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ConveniosNomencladosDeletePrev;
